module.exports = __webpack_public_path__ + "static/media/giact.08f07ec5.jpg";